import { useAuthenticatedRoutes } from "hooks/useAuthenticatedRoutes"
import { useRoutes } from "react-router-dom"
import appRoutes from "routes"

const RoutesWrapper = () => {
  const validRoutes = useAuthenticatedRoutes({
    showHidden: true,
    routes: appRoutes,
  })
  const app = useRoutes(validRoutes)
  return app
}

export default RoutesWrapper
